__turbopack_context__.v({
  "banner": "SwPcjG_banner",
  "clearButton": "SwPcjG_clearButton",
  "stallName": "SwPcjG_stallName",
});
